"use strict";

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GapFillFailedError = /*#__PURE__*/function (_Error) {
  _inherits(GapFillFailedError, _Error);

  var _super = _createSuper(GapFillFailedError);

  function GapFillFailedError(from, to, publisherId, msgChainId, nbTrials) {
    var _this;

    _classCallCheck(this, GapFillFailedError);

    _this = _super.call(this, "Failed to fill gap between ".concat(from.serialize(), " and ").concat(to.serialize()) + " for ".concat(publisherId, "-").concat(msgChainId, " after ").concat(nbTrials, " trials"));
    _this.from = from;
    _this.to = to;
    _this.publisherId = publisherId;
    _this.msgChainId = msgChainId;
    return _this;
  }

  return GapFillFailedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.default = GapFillFailedError;